export const environment = {
  production: true,
  backUrl: "https://dca.setportal.set.or.th/api/",
  loginUrl: "https://www.setportal.set.or.th/setdd/",
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts